<template lang="html">
    <div id="backdropContainerConf" @click="close($event)">
        <div id="containerConf" :class="block ? 'disabled' : ''">

            <ul class="nav nav-tabs" id="contTabsAccess" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="printer-tab" data-bs-toggle="tab" data-bs-target="#printer-tab-pane"
                        type="button" role="tab" aria-controls="printer-tab-pane" aria-selected="true">Impresión</button>
                </li>
            </ul>

            <div class="tab-content" id="confTabs">
                <div class="tab-pane fade show active" id="printer-tab-pane" role="tabpanel" aria-labelledby="printer-tab"
                    tabindex="0">

                    <div class="align-items-start col-12 mt-3">
                        <div class="form-check form-check-inline">
                            <input placeholder="192.168.0.1" class="form-check-input" type="radio" name="printType" value="network" v-model="printType">
                            <label class="form-check-label" for="inlineRadio1">RED</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="printType" value="usb" v-model="printType">
                            <label class="form-check-label" for="inlineRadio2">USB</label>
                        </div>
                    </div>

                    <div v-if="printType == 'network'" class="align-items-start col-12 mt-4 d-flex flex-wrap">
                        <div class="col-auto">
                            <label class="col-form-label">Dirección</label>
                        </div>
                        <div class="ps-2 d-flex" style="flex:1">
                            <input type="text" class="form-control w-100" v-model="printSelected">
                        </div>
                        <div class="w-100 my-2"></div>
                        <div class="col-auto">
                            <label class="col-form-label">RaspberryTV</label>
                        </div>
                        <div class="ps-2 d-flex" style="flex:1">
                            <input type="text" class="form-control w-100" v-model="raspberryIP">
                        </div>
                    </div>

                    <div v-else-if="printType == 'usb'" class="align-items-start col-12 mt-4 d-flex">
                        <div class="col-auto">
                            <label class="col-form-label">Dispositivo</label>
                        </div>
                        <div class="ps-2 d-flex" style="flex:1">
                            <select class="form-select" v-model="printSelected">
                                <option value="">Sin dispositivo</option>
                                <option v-for="usbDevice in usbDevices" :value="usbDevice.deviceId">{{usbDevice.productName}}</option>
                            </select>
                        </div>
                    </div>

                </div>
            </div>

            <button class="btn btn-primary mt-5" type="button" @click="saveConf()">Guardar configuración</button>
            <button class="btn btn-primary mt-5 ms-2" type="button" @click="exit()">Salir</button>
        </div>
    </div>
</template>
<script>
export default {
    
    name: "deviceConfiguration",
    emits:['close', 'electronPass', 'toast'],
    props:{
        printer: {
            default: {},
            type: Object
        },
        catchResponseWS:{ //cadenas indicadoras del dia a listar
            default: () => ({destiny:null,message:"",status:false,for:""}),
            type: Object,
        },
        catchResponseElectron:{ 
            default: () => ({destiny:null,payload:{},reload:false}),
            type: Object,
        },
    },
    
    mounted(){
        if(this.isElectron){
            this.$emit('electronPass', 'getUsbDevices', {})
        }else{
            this.printer.getUSBDevices().then((res)=>{
                this.usbDevices = res;
            });
        }
    },

    watch: {

        printType() {
            this.$emit('electronPass', 'setPrintType', {data: this.printType})
            localStorage.setItem('printerTypeSelected', this.printType);
            this.printSelected = "";
            localStorage.setItem('printerSelected', "");
        },
        catchResponseElectron() {
			if (this.catchResponseElectron.destiny.includes(this.$options.name)) {

				switch (this.catchResponseElectron.payload.action) {
					case "usbList":
                        this.usbDevices = [];
						for (let i=0; i < (this.catchResponseElectron.payload.data).length; i++) {
                            this.usbDevices.push({ 
                                'productName': 'USB-' + String(this.catchResponseElectron.payload.data[i].deviceDescriptor.idProduct) + String(this.catchResponseElectron.payload.data[i].deviceDescriptor.idVendor), 
                                'deviceId': String(this.catchResponseElectron.payload.data[i].deviceDescriptor.idProduct) + String(this.catchResponseElectron.payload.data[i].deviceDescriptor.idVendor) 
                            });
                        }
						return false;
				}

			}
		},
    },

    data() {
        return {
            raspberryIP: (localStorage.raspberry) ? localStorage.raspberry : "",
            printType: (localStorage.printerTypeSelected) ? localStorage.printerTypeSelected : "network",
            printSelected: (localStorage.printerSelected) ? localStorage.printerSelected : "",
            usbDevices:[],
            regIP: new RegExp(/^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/),
            block:false,
        }
    },
    methods:{
        close(e){
            if(e.target.id == "backdropContainerConf"){
                this.exit();
            }
        },
        exit(){
            this.$emit('close')
        },
        validateIP(ip){
            return (this.regIP.test(ip)) ? true : false;
        },
        saveConf(){

            if(this.printType == "usb"){

                if(this.printSelected != null && this.printSelected != ""){

                    if(this.isElectron){
                        this.$emit('electronPass', 'setPrintConfig', this.printSelected);
                        localStorage.setItem('printerSelected', this.printSelected);
                        localStorage.setItem('printerTypeSelected', this.printType);
                        this.exit();
                        return false;
                    }
                    
                    this.block = true;
                    this.printer.getPermisive(this.printSelected).then((res)=>{
                        if(res){
                            this.$emit('toast', 'Permiso adquirido para: ' + this.printSelected);
                            localStorage.setItem('printerSelected', this.printSelected);
                            localStorage.setItem('printerTypeSelected', this.printType);
                        }else{
                            this.$emit('toast', 'Permiso denegado para: ' + this.printSelected);
                        }
                        this.block = false;
                        this.exit();
                    }).catch(()=>{

                        this.$emit('toast', 'Permiso denegado para: ' + this.printSelected);
                        this.block = false;
                        this.exit();
                    })
                }else{
                    this.$emit('toast', 'no hay dispositivo para impresion por lo que es posible que la impresión no proceda');
                    this.exit();
                }

            }else if(this.printType == "network"){


                if(this.validateIP(this.printSelected)){

                    if(this.isElectron){
                        this.$emit('electronPass', 'setPrintConfig', this.printSelected);
                        localStorage.setItem('printerSelected', this.printSelected);
                        localStorage.setItem('printerTypeSelected', this.printType);
                        this.exit();
                        return false;
                    }else{
                        this.$emit('toast', 'IP seleccionada: ' + this.printSelected);
                        localStorage.setItem('printerSelected', this.printSelected);
                        localStorage.setItem('printerTypeSelected', this.printType);
                        this.exit();
                    }
                }else{
                    this.$emit('toast', 'la direccion ip es incorrecta: ejemplo 127.0.0.1');
                }

                if(this.raspberryIP != ''){
                    if(this.validateIP(this.raspberryIP)){
                        localStorage.setItem('raspberry', this.raspberryIP);
                    }else{
                        this.$emit('toast', 'la direccion ip es incorrecta para el raspberry: ejemplo 127.0.0.1');
                    }
                }

            }else{
                this.$emit('toast', 'no hay dispositivo para impresion por lo que es posible que la impresión no proceda');
                this.exit();
            }
            
        }
    },
}
</script>
<style lang="css">
#backdropContainerConf {
    z-index: 3999;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    width: 100vw;
    height: 100vh;
    padding: 0;
    margin: 0;
    top: 0;
    left: 0;
    background-color: gray;
}

#containerConf {
    background-color: var(--contrast1);
    min-height: 250px;
    width: 600px;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    padding: 3em 2em 3em 2em;
    justify-content: center;
    align-items: flex-start;
    align-content: flex-start;
    z-index: 4002;
    border-radius: 4px;
    color: var(--decagenary);
}

#containerConf.disabled{
    pointer-events: none;
}

#contTabsAccess {
    width: 100%;
}

#confTabs {
    width: 100%;
    margin-top: 10px;
}
</style>